import { styled } from 'solid-styled-components';
import type {RowProps} from './row.d';

export const StyledRowComponent = styled.div<RowProps>`
    display: flex;
    ${p => p.justifyContent ? `justify-content: ${p.justifyContent};` : ''}
    ${p => p.alignItems ? `align-items: ${p.alignItems};` : ''}
    ${p => p.gap ? `gap: ${p.gap}rem;` : ''}
`;
